import React, { useState, useEffect } from "react";
import { useApi } from "../../hooks/useApi";
import { useMsal } from "@azure/msal-react";

const DmeStatusUpdateModal = ({ isOpen, onClose, folioData, onSuccess }) => {
    const { post } = useApi();
    const { accounts } = useMsal();
    const user = accounts[0];
    const userIdRaw = user?.localAccountId; // o el campo que uses para ID de usuario
    const userId = userIdRaw && !isNaN(Number(userIdRaw)) ? Number(userIdRaw) : userIdRaw;

    const [selectedStatus, setSelectedStatus] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    // Estados permitidos seg�n el estado actual
    const statusOptions = {
        0: { label: "Por Clasificar", allowedStates: [6, 4, 3] },
        3: { label: "Retenido", allowedStates: [0, 6, 4] },
        4: { label: "Cancelado", allowedStates: [0, 6, 3] },
        6: { label: "En Aclaraci\u00F3n", allowedStates: [0, 4] },
        10: { label: "Clasificado", allowedStates: [] }, // Final, no permite cambios
    };

    const statusLabels = {
        0: "Por Clasificar",
        3: "Retenido",
        4: "Cancelado",
        6: "En Aclaraci\u00F3n",
        10: "Clasificado",
    };

    const statusColors = {
        0: "bg-green-100 text-green-700",
        1: "bg-gray-100 text-gray-700",
        2: "bg-gray-100 text-gray-700",
        3: "bg-purple-100 text-purple-700",
        4: "bg-red-100 text-red-700",
        5: "bg-pink-100 text-pink-700",
        6: "bg-orange-100 text-orange-700",
        10: "bg-blue-100 text-blue-700",
    };

    useEffect(() => {
        if (isOpen) {
            setSelectedStatus(null);
            setError(null);
        }
    }, [isOpen]);

    const getCurrentStatusLabel = () => {
        return statusLabels[folioData?.status] || "Desconocido";
    };

    const getAllowedStates = () => {
        const current = folioData?.status || 0;
        return statusOptions[current]?.allowedStates || [];
    };

    const handleUpdateStatus = async () => {
        if (selectedStatus === null || selectedStatus === undefined) {
            setError("Selecciona un nuevo estatus");
            return;
        }

        setLoading(true);
        setError(null);

        try {
            // Enviar el objeto directamente (no anidado en "body")
            const payload = {
                returnId: folioData.returnId,
                reference: folioData.reference,
                branch: folioData.branch,
                newStatus: selectedStatus,
                userId: 2,
            };

            const response = await post("ActualizaFolioStatus", payload);

            if (response?.success) {
                onSuccess?.();
                onClose();
            } else {
                setError(response?.message || response?.error || "Error al actualizar el estatus");
            }
        } catch (err) {
            setError(err.response?.data?.message || err.message || "Error al procesar la solicitud");
        } finally {
            setLoading(false);
        }
    };

    if (!isOpen) return null;

    const allowedStates = getAllowedStates();

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-xl p-6 max-w-md w-full mx-4">
                {/* Header */}
                <div className="border-b pb-4 mb-4">
                    <h3 className="text-lg font-semibold">Cambiar Estatus del Folio</h3>
                    <p className="text-sm text-gray-600 mt-1">
                        Folio: {folioData?.reference} | Sucursal: {folioData?.branch}
                    </p>
                </div>

                {/* Estado actual */}
                <div
                    className={`mb-6 p-3 rounded ${statusColors[folioData?.status] || "bg-gray-100 text-gray-700"
                        }`}
                >
                    <p className="text-sm opacity-80">Estado actual:</p>
                    <p className="font-semibold text-gray-800">{getCurrentStatusLabel()}</p>
                </div>

                {/* Estados permitidos */}
                {allowedStates.length > 0 ? (
                    <div className="mb-6">
                        <label className="block text-sm font-medium text-gray-700 mb-3">
                            Nuevo estatus:
                        </label>
                        <div className="space-y-2">
                            {allowedStates.map((status) => (
                                    <label
                                        key={status}
                                        className={`flex items-center p-2 border rounded cursor-pointer transition
                                        ${statusColors[status] || "bg-gray-50 text-gray-700"}
                                        ${selectedStatus === status ? "ring-2 ring-blue-400" : "hover:opacity-80"}
                                    `}
                                    >
                                    <input
                                        type="radio"
                                        name="status"
                                        value={status}
                                        checked={selectedStatus === status}
                                        onChange={() => setSelectedStatus(status)}
                                        className="mr-3"
                                    />
                                    <span className="text-sm">{statusLabels[status]}</span>
                                </label>
                            ))}
                        </div>
                    </div>
                ) : (
                    <div className="mb-6 p-3 bg-red-50 border border-red-200 rounded">
                        <p className="text-sm text-red-700">
                            Este folio no puede cambiar de estatus (estatus final).
                        </p>
                    </div>
                )}

                {/* Error */}
                {error && (
                    <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded">
                        <p className="text-sm text-red-700">{error}</p>
                    </div>
                )}

                {/* Botones */}
                <div className="flex gap-3 justify-end border-t pt-4">
                    <button
                        onClick={onClose}
                        disabled={loading}
                        className="px-4 py-2 text-gray-700 border border-gray-300 rounded hover:bg-gray-50 disabled:opacity-50"
                    >
                        Cancelar
                    </button>
                    <button
                        onClick={handleUpdateStatus}
                        disabled={loading || selectedStatus === null || selectedStatus === undefined || allowedStates.length === 0}
                        className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                        {loading ? "Actualizando..." : "Actualizar"}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DmeStatusUpdateModal;